<template>
  <div class="wp75 top-top">
    <!-- <Breadcrumb 
      :title="title"
    /> -->
    <!-- 公告 -->
    <!-- <carousel/> -->
    <div class="all-div">
      <div class="left-div pr10">
        <el-form
          :model="ruleForm"
          ref="dataFormRef"
          label-width="130px"
        >
        <div class="company-info">
          <div class="display-flex center-flex">
            <el-button class="data-btn" type="primary">
              <img src="@/assets/images/a-jiluwendang 2@2x.png" class="icon-jiluwendang"/>
              生成数据报告
            </el-button>
            <img
              v-if="ruleForm.logoPicture"
              :src="prodUrl+ruleForm.logoPicture"
              class="company_pic"
            />
            <GsMediaPh v-else class="company_pic" label="暂无图片" />
            <div class="company-name">
              <div class="company-title">{{ displayTitle }}</div>
              <div class="company-code">
                <span>统一社会信用代码：</span>
                <GsVal class="ml5" :value="ruleForm.unifiedSocialCreditCode || ruleForm.creditCode" />
                <img src="@/assets/images/fuzhi-14 2@2x.png" class="icon-fuzhi hand-cursor ml5"/>
              </div>
              <div class="display-flex">
                <div
                  v-for="(item, index) in dataInfo"
                  :key="index"
                  class="data-item mr10"
                >
                  <span :class="index < 3 ? 'info-btn' : 'info-last'">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bg mt10">
            <el-form-item label-width="120px" label="企业简介：">
              <div class="display-flex space-between intro-row">
                <div
                  v-if="ruleForm.enterpriseProfile || ruleForm.introduction || ruleForm.enterpriseAbbreviation"
                  :class="showBtn ? 'ellipsis-one' : ''"
                >
                  {{ ruleForm.enterpriseProfile || ruleForm.introduction || ruleForm.enterpriseAbbreviation }}
                </div>
                <div v-else class="gs-text-ph">企业简介暂未公开，后续将补充主营业务、服务范围与公开登记信息。</div>
                <div class="detail-btn hand-cursor" v-if="ruleForm.enterpriseProfile || ruleForm.introduction">
                  <div @click="detailMore" v-if="showBtn">详情 <span class="expand-icon">▼</span></div>
                  <div @click="detailLess" class="expanded" v-else>收起 <span class="expand-icon">▼</span></div>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="">
          <div class="form-card">
            <div>
              <TitleTool title="企业工商信息" />
              <div class="detail-form bg mt10">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="法定代表人：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.legalRepresentative" />
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="工商注册号：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.businessRegistrationNumber" />
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="注册资本：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.registeredCapital" />
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="成立日期：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.dateOfEstablishment" />
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="营业期限：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.operatingTerm" />
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="实缴资本：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.contributedCapital" />
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="办公地址：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.officeAddress" />
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="参保人数：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.insuredNumber" />
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="企业规模：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.enterpriseScale" />
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="企业类型：">
                      <span class="ellipsis-one">
                        <GsVal :value="transFormEnum(typeOfEnterpriseEnum, ruleForm.typeOfEnterprise)" />
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="人员规模：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.personnelSize" />
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="企业官网：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.url" />
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="登记机关：">
                      <span class="ellipsis-one">
                        <GsVal :value="ruleForm.registrationAuthority" />
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="电话：">
                      <GsVal :value="ruleForm.phone" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="邮箱：">
                      <GsVal :value="ruleForm.email" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="DCMM等级：">
                      <span>
                    <GsVal :value="transFormEnum(DCMNSelectList, ruleForm.dcmmRating)" />
                  </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="所属行业：">
                      <GsVal :value="transFormEnum(industryEnum, ruleForm.industry, true)" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="企业简称：">
                      <GsVal :value="ruleForm.enterpriseAbbreviation" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12"><el-form-item label="英文名称："><GsVal :value="ruleForm.englishName" /></el-form-item></el-col>
                  <el-col :span="12"><el-form-item label="统一社会信用代码："><GsVal :value="ruleForm.unifySocialCreditCode" /></el-form-item></el-col>
                </el-row>
                <el-row>
                  <el-col :span="12"><el-form-item label="所属地区："><GsVal :value="ruleForm.administrativeDivisionName" /></el-form-item></el-col>
                  <el-col :span="12"><el-form-item label="注册详细地址："><GsVal :value="ruleForm.registeredAddressDetail" /></el-form-item></el-col>
                </el-row>
                <el-row>
                  <el-col :span="12"><el-form-item label="国标行业："><GsVal :value="ruleForm.nationalIndustry" /></el-form-item></el-col>
                  <el-col :span="12"><el-form-item label="纳税人资质："><GsVal :value="ruleForm.taxpayerQualification" /></el-form-item></el-col>
                </el-row>
                <el-row>
                  <el-col :span="12"><el-form-item label="登记状态："><GsVal :value="ruleForm.registrationStatus" /></el-form-item></el-col>
                  <el-col :span="12"><el-form-item label="联系人："><GsVal :value="ruleForm.contactName" /></el-form-item></el-col>
                </el-row>
                <el-row>
                  <el-col :span="12"><el-form-item label="职位："><GsVal :value="ruleForm.contactPosition" /></el-form-item></el-col>
                  <el-col :span="12"><el-form-item label="产品介绍："><GsVal :value="ruleForm.companyProductIntroduction || ruleForm.companyProduct" /></el-form-item></el-col>
                </el-row>
                <el-row>
                  <el-col :span="24"><el-form-item label="经营范围："><GsVal :value="ruleForm.businessScope" /></el-form-item></el-col>
                </el-row>
                <el-row>
                  <el-col :span="24"><el-form-item label="其他内容（工商信息）："><GsVal :value="ruleForm.otherContentBusiness" /></el-form-item></el-col>
                </el-row>
                <el-row>
                  <el-col :span="24"><el-form-item label="其他内容（企业基本信息）："><GsVal :value="ruleForm.otherContentBasic" /></el-form-item></el-col>
                </el-row>
              </div>
            </div>
            <EnterpriseRelatedLists
              :enterprise-id="ruleForm.id"
              :enterprise-name="ruleForm.enterpriseName"
              :business-options="labelList"
              :is-demand="isDemandEnterprise"
            />
<div class="mt20">
              <TitleTool title="公司产品介绍" />
              <div class="detail-form bg mt10">
                <div v-if="ruleForm.companyProductIntroduction" class="product-intro">{{ ruleForm.companyProductIntroduction }}</div>
                <div v-else class="section-empty">公司产品介绍暂未公开</div>
              </div>
            </div>
          </div>
          </div>
        </el-form>
      </div>
        <!-- 热点新闻 -->
      <div class="news">
        <div class="news-content">
          <div class="news-conter-left">
            <div class="top new-top blue-text center-flex fw700 mb5">
              <div class="display-flex center-flex">
                <img src="@/assets/images/xinwenzixun@2x.png" alt="" class="icon-rd">
                <span class="fs20 ml10 title-text">新闻动态</span>
              </div>
              <div>
                <span class="more-text mr5 fs14 hand-cursor" @click="moreClick">更多</span>
                <img src="@/assets/images/＞＞@2x.png" class="icon-more-big blue-text"/>
              </div>
            </div>
              <div class="news-title">
                <div
                  v-for="(itemNew, indexNew) in newTab"
                  :key="indexNew"
                  class="title-type hand-cursor"
                  :class="activeName + '' === itemNew.id + '' ? 'title-type' : 'no-click-text'"
                  @click="handleClick(itemNew)"
                >
                  <div>
                    {{ itemNew.tabName }}
                  </div>
                </div>
              </div>
              <div v-if="newDataList && newDataList.length > 0">
                <div
                  class="newsDetail-content"
                  v-for="(item, i) in newDataList"
                  :key="i"
                >
                  <div class="newsDetail-left">
                    <img :src="prodUrl+item.homePicture" alt="" class="pic-img"/>
                  </div>
                  <div class="newsDetail-right">
                    <div class="display-flex center-flex">
                      <div class="newsDetail-right-title hand-cursor" @click="openNewDetail(item)">{{ item.chineseTitle }}</div>
                    </div>
                    <div class="newsDetail-right-text opa6 ellipsis hand-cursor" @click="openNewDetail(item)">{{ item.digest }}</div>
                    <div class="right-bottom display-flex space-between">
                      <div class="display-flex center-flex">
                        <img src="@/assets/images/wangluo-5@2x(1).png" alt="" class="icon-pic" />
                        <span class="opa6 ml5">
                          数据来源：{{ item.newsSource }}
                        </span>
                      </div>
                      <GsShare
                        :id="item.id"
                        :title="item.chineseTitle"
                        :summary="item.digest"
                        :image="prodUrl + item.homePicture"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <NoData />
              </div>
          </div>
          <div class="news-conter-right">
            <userDetail :userDetailData="newsDetailData"></userDetail>
            <Interview class="mt20"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NoData from '@/components/NoData/index.vue'
import userDetail from "@/components/UserDetail";
import Interview from "@/components/Interview";
import { getNewsList } from "@/api/api";
import { enterpriseInfoDetail } from '@/api/Home';
import { getDataType, regionList } from '@/api/Layout/index.js'
import {enumType} from '@/utils/enum.js'
import carousel from "@/views/Home/components/carousel/index.vue";
import GsShare from '@/components/GsShare/index.vue'
import GsMediaPh from '@/components/GsMediaPh/index.vue'
import GsVal from '@/components/GsVal/index.vue'
import EnterpriseRelatedLists from '@/components/EnterpriseRelatedLists/index.vue'
import { P, routeId } from '@/router/paths'

export default {
    name: 'DataProviderDetails',
    components: { userDetail, Interview, NoData, carousel, GsShare, GsMediaPh, GsVal, EnterpriseRelatedLists },
    data() {
      return {
        title: (this.$route.meta && this.$route.meta.title) || '',
        prodUrl:"https://shujuzichan.com/xwzx",
        option: [],
        labelList: [],
        DCMNSelectList: [],
        areaList: [],
        companyProductList:[],
        typeOfEnterpriseEnum: [],
        industryEnum: [],
        dataAgingEnum: [],
        administrativeDivisionList:[],
        companyForm: {},
        ruleForm: {},
        newsDetailData:[],
        activeName: '3',
        newDataList: [],
        showBtn: true,
        newTab: [
          {
            tabName: '企业新闻',
            id: 3,
            dataList: []
          },
          {
            tabName: '行业新闻',
            id: 5,
            dataList: []
          },
          {
            tabName: '地区新闻',
            id: 2,
            dataList: []
          }
        ],
        dataInfo: ['合合信息（688615.SH）','专精特新中小企业', 'A股｜688615合合信息','数据服务商','专精特新肖中企业','高新技术企业'],
        aaa : '该数据资源依托国家医疗保障局的医保信息平台，在药品该数据资源依托国家医疗保障局的医保信息平台，在药品耗材追溯信息系统中，产生药品追溯码、医保编码、商品码映射关系信息，方便参保人、定点医药机构、药品生产流通企业，查询药品基础信息、三码映射关系等信息。耗材追溯信息系统中，产生药品追溯码、医保编码、商品码映射关系信息，方便参保人、定点医药机构、药品生产流通企业，查询药品基础信息、三码映射关系等信息。'
      }
    },
    mounted() {
      this.getNewList()
      const enterpriseId = this.$route.params.id || routeId(this.$route, 'enterpriseId', 'id', 'Id')
      this.init(enterpriseId)
      this.getNewTabList(3)
    },
    computed: {
      displayTitle() {
        return this.ruleForm.enterpriseName || this.title || '企业信息'
      },
      isDemandEnterprise() {
        const type = this.ruleForm && this.ruleForm.type
        return type === 6 || type === '6' || (typeof type === 'string' && type.indexOf('6') !== -1)
      },
      transFormEnum () {
      return function (enumList, value, multi) {
        if(value) {
          let valObj = []
          if(multi) {
            valObj = JSON.parse(value)
          } else {
            valObj = value.split(',').map(item => item.trim())
          }
          let labelListEnum = []
          if(enumList && enumList.length > 0) {
            enumList.forEach(item => {
              valObj && valObj.forEach(itemObj => {
                if(itemObj === item.value) {
                  labelListEnum.push(item.label)
                }
              })
            })
          }
          return labelListEnum.join(',')
        } else {
          return ''
        }
      }
    }
    },
    methods: {
      moreClick() {
        this.$router.push(P.news)
      },
      detailLess () {
        this.showBtn = true
      },
      detailMore () {
        this.showBtn = false
      },
      getNewList () {
        var formData = {};
        formData["pageNum"]=1;
        formData["pageSize"]=10;
        formData["type"]=2;
        formData["whetherPublish"]='1';
        getNewsList(formData).then((response) => {
          this.newsDetailData = response.rows;
        })
      },
      handleClick(tab){
        console.log('tab', tab)
        this.activeName = tab.id
        this.getNewTabList(tab.id)

      },
      getNewTabList (rangeType) {
        var formData = {};
        formData["pageNum"]=1;
        formData["pageSize"]=10;
        formData["rangeType"]=+rangeType;
        formData["status"]=0
        formData["whetherPublish"]='1';
        getNewsList(formData).then((response) => {
          this.newDataList = response.rows || [];
          console.log('this.newDataList', this.newDataList)
        })
      },
      // 地区
      regionArea() {
        regionList().then(resArea => {
          if(resArea && resArea.data && resArea.data.length > 0) {
            this.areaList = resArea.data
          } else {
            this.areaList = []
          }
        }).catch(()=>{})
      },
      // 枚举
      async getData(type) {
        try {
          const res = await getDataType(type);
          if (res && res.data && res.data.length > 0) {
            if(type === 'sys_business_type') {
              this.labelList = enumType(res.data)
            }
            if(type === 'sys_yes_no') {
              this.option = enumType(res.data)
            }
            if(type === 'sys_enterprise_dcmm_rating') {
              this.DCMNSelectList = enumType(res.data)
            }
            if(type === 'sys_enterprise_type') {
              this.typeOfEnterpriseEnum = enumType(res.data)
            }
            if(type === 'sys_data_aging') {
              this.dataAgingEnum = enumType(res.data)
            }
            if(type === 'sys_company_product') {
              this.companyProductList = enumType(res.data)
            }
            if(type === 'sys_product_service_industry_type') {
              this.industryEnum = enumType(res.data)
            }
          }
        } catch (error) {
          console.error("Error fetching data:", error)
        }
      },
      init(enterpriseId) {
        this.getData('sys_enterprise_type')
        this.getData('sys_data_aging')
        this.getData('sys_business_type')
        this.getData('sys_enterprise_dcmm_rating')
        this.getData('sys_yes_no')
        this.getData('sys_company_product')
        this.getData('sys_product_service_industry_type')
        this.regionArea()
        this.loading = true
        enterpriseInfoDetail(enterpriseId).then(res=>{
          this.loading = false
          this.ruleForm = res.data || {}
        }).catch(()=>{
          this.loading = false
        })
      },
      openNewDetail(item) {
        this.$router.push(P.newsDetail(item.id))
      }
    }
}
</script>
<style lang="css" scoped>
.company-info {
  margin: 10px auto;
  position: relative;
  background: linear-gradient( 180deg, #FFFFFF 0%, #F6F9FF 100%);
  border-radius: 8px;
  padding: 10px;
}
.company-name  {
  /* width: 100%; */
}
.left-div {
  width: 100%;
  .new-text {
    line-height: 36px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: flex-start;
    .new-title {
      margin-left: 10px;
      width: 85%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.company_pic {
  width: 106px;
  height: 106px;
  border-radius: 10px;
  margin-right: 20px;
  overflow: hidden;
  object-fit: cover;
}
.gs-text-ph {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: linear-gradient(90deg, #F4F8FF 0%, #FFFFFF 100%);
  border: 1px dashed #C5D8F7;
  color: #7B8BA3;
  font-size: 13px;
  line-height: 22px;
}
.pic_text {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center
}
.data-btn {
  position: absolute;
  right: 10px;
  top: 10px;
}
.data-btn.el-button--primary {
  background: #E8F2FF;
  border-color: #E8F2FF;
  border-radius: 8px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 22px;
  color: #0165FF;
  line-height: 34px;
  padding: 4px 10px;
}
.icon-jiluwendang {
  width: 34px;
  height: 38px;
}
.company-title {
  height: 36px;
  font-family: AlibabaPuHuiTi_3_85_Bold;
  font-size: 32px;
  color: #111824;
  line-height: 36px;
  text-align: left;
  font-weight: 700;
  margin-bottom: 10px;
}
.company-code {
  display: flex;
  align-items: center;
  height: 22px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  margin-bottom: 10px;
}
.code-color {
  color: #666;
}
.icon-fuzhi {
  width: 14px;
  height: 14px;
}
.data-item {
  height: 14px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 12px;
  color: #0165FF;
  line-height: 14px;
  text-align: center;
}
.info-btn {
  background: #D6E5FE;
  border-radius: 4px;
  padding: 4px 6px;
}
.info-last {
  background: #E2E2E2;
  border-radius: 4px;
  color: #333333;
  padding: 4px 6px;
}
.el-form-item {
  margin-bottom: 0px;
}
::v-deep .el-form-item__label {
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 16px;
  color: #333333;
  line-height: 40px;
}
::v-deep .el-form-item__content {
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 16px;
  color: #666666;
  line-height: 40px;
}
.detail-btn {
  width: 140px;
  height: 36px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 16px;
  color: #0165FF;
  line-height: 36px;
  text-align: left;
  font-style: normal;
}
.expand-icon {
  display: inline-block;
  transition: transform 0.3s;
  margin-left: 2px;
}
.expanded .expand-icon {
  transform: rotate(180deg);
}
.collapsed {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.bg {
  background: #FFFFFF;
  border-radius: 8px;
}
.form-card {
  background-color: rgba(75, 145, 255, .07);
  border-radius: 4px;
  padding: 20px 10px;
}
.little-title {
  height: 20px;
  font-family: AlimamaFangYuanTiVF-SemiBold, AlimamaFangYuanTiVF-SemiBold;
  font-weight: bold;
  font-size: 20px;
  color: #111824;
  line-height: 24px;
}
.icon-title {
  width: 28px;
  height: 18px;
}
.detail-form {
  padding: 15px 5px;
}
.product-intro {
  padding: 8px 12px;
  color: #111824;
  font-size: 14px;
  line-height: 24px;
}
.section-empty {
  min-height: 48px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  color: #6B7789;
  font-size: 14px;
  line-height: 22px;
}
.detail-form .el-col {
  border-right: 1px solid rgba(118,118,118,0.13);
}
.detail-form .el-row .el-col:last-child {
  border-right: none;
}
.news {
  margin: 20px 0;
}
.news-content{
  display: flex;
}
.news-conter-left{
  width: 67%;
  height: 100%;
}
.news-conter-right {
  width: 33%;
  height: 100%;
  margin-left: 10px;
}
.new-top {
  background-image: url('@/assets/images/矩形@2x.png');
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.icon-rd {
  width: 55px;
  height: 40px;
}
.news-title {
  display: flex;
  margin-bottom: 20px;
}
.title-type {
  width: 120px;
  height: 36px;
  background: linear-gradient( 263deg, #428DFF 0%, #0062F9 100%);
  box-shadow: 2px 2px 4px 0px rgba(0,107,206,0.3);
  border-radius: 8px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 36px;
  text-align: center;
  margin-right: 10px;
}
.no-click-text {
  width: 120px;
  height: 36px;
  background: #EEF3FF;
  border-radius: 8px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 16px;
  color: #606060;
  line-height: 36px;
  text-align: center;
}
.newsDetail-content {
  display: flex;
  width: 100%;
  margin-top: 10px;
  height: 180px;
  background: linear-gradient( 270deg, #ECF4FF 0%, #FFFFFF 36%, #F2F7FF 63%, #8DBAFF 100%);
  border-radius: 8px;
}
.newsDetail-left{
  text-align: center;
  flex-shrink:0;
}
.pic-img{
  height: 180px;
  width: 280px;
}
.newsDetail-right {
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.type-icon {
  width: 80px;
  height: 24px;
  background: linear-gradient( 263deg, #5799FF 0%, #0165FF 100%);
  box-shadow: 2px 2px 4px 0px rgba(46,119,233,0.19);
  border-radius: 4px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 24px;
  text-align: center;
  margin-right: 10px;
  margin-top: 5px;
}
.newsDetail-right-title {
  width: 100%;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 30px;
  font-family: AlibabaPuHuiTi_3_85_Bold;
  font-size: 22px;
  color: #111824;
  line-height: 30px;
}
.newsDetail-right-text {
  margin: 10px;
  flex-shrink: 0;
  height: 72px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 14px;
  color: #111824;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}
.icon-pic {
  width: 12px;
  height: 12px;
}
.top-top {
  margin-top: 50px;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}
.all-div,
.news,
.news-content {
  max-width: 100%;
  min-width: 0;
}
.news-content {
  display: flex;
}
.news-conter-left,
.news-conter-right {
  min-width: 0;
}
.company-info > .display-flex {
  flex-wrap: wrap;
  min-width: 0;
}
@media (max-width: 960px) {
  .all-div {
    padding-bottom: 16px;
  }
  .company-info {
    padding: 12px;
  }
  .company-info > .display-flex {
    align-items: flex-start;
    gap: 10px;
  }
  .company_pic {
    width: 72px;
    height: 72px;
    margin-right: 12px;
  }
  .company-title {
    font-size: 18px !important;
    line-height: 1.3 !important;
    min-height: 0 !important;
    height: auto !important;
  }
  .company-code {
    height: auto !important;
    font-size: 12px !important;
    line-height: 18px;
    flex-wrap: wrap;
  }
  .data-btn {
    position: static;
    width: 100%;
    order: -1;
  }
  .data-btn.el-button--primary {
    font-size: 13px !important;
    line-height: 20px !important;
    padding: 6px 10px !important;
    width: 100%;
  }
  .icon-jiluwendang {
    width: 20px;
    height: 22px;
  }
  .form-card {
    padding: 12px 8px;
  }
  .detail-form :deep(.el-col),
  .form-card :deep(.el-col) {
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
  .detail-form :deep(.el-form-item),
  .form-card :deep(.el-form-item),
  .company-info :deep(.el-form-item) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 10px;
  }
  .detail-form :deep(.el-form-item__label),
  .form-card :deep(.el-form-item__label),
  .company-info :deep(.el-form-item__label) {
    width: auto !important;
    text-align: left !important;
    line-height: 1.35 !important;
    height: auto !important;
    padding: 0 0 2px !important;
    font-size: 12px !important;
    color: #64748b !important;
  }
  .detail-form :deep(.el-form-item__content),
  .form-card :deep(.el-form-item__content),
  .company-info :deep(.el-form-item__content) {
    margin-left: 0 !important;
    font-size: 13px !important;
    line-height: 1.45 !important;
  }
  .intro-row {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }
  .news-content {
    flex-direction: column;
  }
  .news-conter-left,
  .news-conter-right {
    width: 100%;
    margin-left: 0;
  }
  .top-top {
    margin-top: 16px;
  }
}
</style>